const features = [
  {
    icon: 'ri-home-smile-line',
    title: 'Fully Furnished',
    desc: 'Move in with just your suitcase. Every room is ready with quality furniture and fittings.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'All Bills Included',
    desc: 'Electricity, gas, water — all covered in your weekly rent. No surprise bills, ever.',
  },
  {
    icon: 'ri-wifi-line',
    title: 'Free Unlimited Wi-Fi',
    desc: 'High-speed internet throughout the property, included at no extra charge.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Maintenance & Cleaning',
    desc: 'Regular cleaning and prompt maintenance included — we keep the property in top condition for you.',
  },
];

export default function FeaturesStrip() {
  return (
    <section className="bg-navy-800 py-14">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col items-start gap-4 p-6 bg-navy-900 rounded-lg border border-white/10 hover:border-gold-500/40 transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded bg-gold-500/15 text-gold-400">
                <i className={`${f.icon} text-xl`} />
              </div>
              <div>
                <h3 className="font-semibold text-white text-base mb-1.5">{f.title}</h3>
                <p className="text-white/55 text-sm leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
